module.exports = require('./helpers/bundle-url').getBundleURL('5HgvK') + "logo.c51670a8.svg";